import { createRouter, createWebHistory } from 'vue-router'
import Login from '../views/Login.vue'
import Books from '../views/Books.vue'
import Reader from '../views/Reader.vue'
import AdminUsers from '../views/admin/Users.vue'
import AdminBooks from '../views/admin/Books.vue'

const routes = [
  {
    path: '/',
    redirect: '/books'
  },
  {
    path: '/login',
    name: 'Login',
    component: Login,
    meta: { requiresAuth: false }
  },
  {
    path: '/books',
    name: 'Books',
    component: Books,
    meta: { requiresAuth: true }
  },
  {
    path: '/reader/:bookId',
    name: 'Reader',
    component: Reader,
    meta: { requiresAuth: true },
    props: true
  },
  {
    path: '/admin/users',
    name: 'AdminUsers',
    component: AdminUsers,
    meta: { requiresAuth: true, requiresAdmin: true }
  },
  {
    path: '/admin/books',
    name: 'AdminBooks',
    component: AdminBooks,
    meta: { requiresAuth: true, requiresAdmin: true }
  }
]

const router = createRouter({
  history: createWebHistory(),
  routes
})

// 路由守卫
router.beforeEach((to, from, next) => {
  const isAuthenticated = localStorage.getItem('token') !== null
  const userInfo = JSON.parse(localStorage.getItem('userInfo') || '{}')
  const isAdmin = userInfo.is_admin || false

  if (to.meta.requiresAuth && !isAuthenticated) {
    next('/login')
  } else if (to.meta.requiresAdmin && (!isAuthenticated || !isAdmin)) {
    next('/books')
  } else {
    next()
  }
})

export default router